import React, { useEffect, useState } from 'react'
import { Loader } from 'components/Shared/Loader'
import { CarForm, CarSchema, mapCarToFormValues } from 'components/Car/CarForm'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { editCar, fetchCar } from 'services/CarService'
import { HTTP_404_ERROR } from 'Constants'
import { useErrorHandling } from 'context/errorHandling'
import { useNavigatePrevent } from 'context/navigatePrevent'
import { FormikForm } from 'components/Shared/FormikForm'
import Module from 'constants/customFieldModules'

export function EditCarForm (props) {
  const [updatedDialogOpen, setUpdatedDialogOpen] = useState(false)
  const [car, setCar] = useState(null)

  const { handleError } = useErrorHandling()
  const { setNavigationUnlocked } = useNavigatePrevent()

  useEffect(() => {
      fetchCar(props.match.params.id).then(response => {
          setCar(response)
        }
      ).catch(error => handleError(error, {
        [HTTP_404_ERROR]: 'notifications.error.carNotFound'
      }).then(() => {
        setNavigationUnlocked(history => history.push('/cars'))
      }))
    }, [props.match.params.id, handleError, setNavigationUnlocked]
  )

  function handleSubmit (values, onSuccess) {
    editCar({
      id: car.id,
      ...values
    })
      .then(() => onSuccess(car.id)
        .then(() => setUpdatedDialogOpen(true))
        .catch(handleError)
      )
      .catch(handleError)
  }

  return <div>
    <SuccessDialog open={updatedDialogOpen}
                   onClose={() => {
                     setUpdatedDialogOpen(false)
                     setNavigationUnlocked(history => history.push('/cars'))
                   }} content={'notifications.success.updatedCar'}/>
    {car ?
      <FormikForm
        initialValues={mapCarToFormValues(car)}
        validationSchema={CarSchema}
        onSubmit={handleSubmit}
        customFields={{
          module: Module.Cars,
          entityId: car?.id
        }}>
        <CarForm
          translateTitleLabel={'editCarTitle'}
          initialFiles={car.files}/>
      </FormikForm> :
      <Loader/>
    }
  </div>

}
